import { Close } from "@css/icons/SVG"
import { maskStyle } from "@css/js-style"
import styles from "@css/modules/SaveSearchModal.module.scss"
import { Toggle } from "@components/Toggle"
import cn from "classnames"
import { RadioButtons } from "@components/RadioButtons"
import { Modal } from "antd"
import React, { ReactNode } from "react"

export type Frequency = "asap" | "daily" | "weekly" | "2x-daily"
type Props = {
    getButtons: () => ReactNode
    onClose: () => void
    loading: boolean
    title?: string
    inputRef: React.RefObject<HTMLInputElement>
    onToggleNotification: (isOn: boolean) => void
    withNotification: boolean
    frequency: Frequency
    onChangeFrequency: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export function SaveSearchModal(props: Props) {
    const { getButtons, onClose, loading, title = "Please enter filter name", onChangeFrequency, frequency, inputRef, onToggleNotification, withNotification } = props
    return (
        <Modal
            centered
            width={850}
            closeIcon={<Close />}
            maskStyle={maskStyle}
            className={styles.saveSearchBtnModal}
            footer={null}
            title={title}
            open
            onCancel={onClose}
            confirmLoading={loading}>
            <input placeholder="Give your filter a name" ref={inputRef} className={`${styles.saveSearchModalInput} ant-input`} />
            <>
                <label className={styles.toggleLabel}>
                    Email Notifications
                    <Toggle checked={withNotification} className={styles.toggleElement} onChange={onToggleNotification} />
                </label>
                <div className={cn(!withNotification && styles.notificationShade)}>
                    <RadioButtons
                        value={frequency}
                        classes={{
                            root: styles.notificationRadioRoot,
                            label: styles.notificationRadioLabel
                        }}
                        onChange={onChangeFrequency}
                        name="notificationType"
                        items={[
                            {
                                id: "asap",
                                label: (
                                    <div>
                                        <strong>Instant</strong> - Could be as frequent as every hour
                                    </div>
                                )
                            },
                            {
                                id: "daily",
                                label: (
                                    <div>
                                        <strong>Daily</strong> - One email per day in the afternoon
                                    </div>
                                )
                            },
                            {
                                id: "2x-daily",
                                label: (
                                    <div>
                                        <strong>Twice per day</strong> - One email in the morning and one in the afternoon
                                    </div>
                                )
                            },
                            {
                                id: "weekly",
                                label: (
                                    <div>
                                        <strong>Weekly</strong> - One email per week, sent on Sunday
                                    </div>
                                )
                            }
                        ]}
                    />
                    <div className={styles.notificationDesc}>
                        We scan every broker&apos;s website hourly. How often should we notify you of new listings or those with price reductions that match your criteria?
                    </div>
                </div>
            </>
            <div className={styles.saveSearchModalFooter}>{getButtons()}</div>
        </Modal>
    )
}
